// React
import React, { useState, useRef, useEffect } from "react";
import * as ModelCache from "../libs/ModelCache";
import * as EventifyAPI from "../libs/EventifyAPI";
// import { Link } from "react-router-dom";

// Style
import "react-bootstrap-typeahead/css/Typeahead.css";
import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

// ant components
import { Collapse } from "antd";

// UUID
const uuidv4 = require("uuid/v4");

// DateTime
const { DateTime } = require("luxon");

// ant design stuff
const { Panel } = Collapse;

const ListSidePaneListSection = React.forwardRef((props, ref) => {
  const [personid, setPersonId] = useState("");
  const [person, setPerson] = useState({});
  const [listsInfo, setListsInfo] = useState({});
  const [reloadProtocol, setReloadProtocol] = useState(null);
  const [notesToUserInfo, setNotesToUserInfo] = useState({});
  const [notes, setNotes] = useState([]);

  function callback(key) {
    console.log(key);
  }

  // Default modal stuff
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  // Allow hierarchy to call functions on this component
  // the ref might not actually be necessary
  const modalComponentRef = React.useRef();
  React.useImperativeHandle(ref, () => ({
    handleShowImperative: passedPersonId => {
      handleShow();
    }
  }));

  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    setNotes(props.notes);
  }

  function closeMe() {
    setShow(false);
  }

  function formatTime(unixTime) {
    const timeObject = DateTime.fromMillis(parseInt(unixTime)).setZone(
      "America/Los_Angeles"
    );
    const timeString = timeObject.toLocaleString(DateTime.DATE_MED);

    return <p className="timestamp">{timeString}</p>;
  }

  // TODO: Replace when creating view model for the side pane
  function renderIndividualList(listid) {
    return (<></>);
    // if (
    //   listsInfo[listid] === null ||
    //   typeof listsInfo[listid] === "undefined"
    // ) {
    //   ModelCache.getListForId(
    //     listid,
    //     result => {
    //       var info = listsInfo;
    //       if (result != null && typeof result !== "undefined") {
    //         info[listid] = result;
    //       } else {
    //         info[listid] = {};
    //       }
    //       setListsInfo(info);
    //       setReloadProtocol(uuidv4());
    //     }
    //   );
    //   return <></>;
    // } else {
    //   const listEntry = listsInfo[listid];
    //
    //   var notesForPerson = [];
    //   for (var k = 0; k < props.notes.length; k++) {
    //     const note = props.notes[k];
    //     if (note.listid === listid) {
    //       notesForPerson.push(note);
    //     }
    //   }
    //
    //   return (
    //     <Collapse defaultActiveKey={["1"]} onChange={callback}>
    //       <Panel header={listEntry.name} key={listEntry.listid}>
    //         <div className="top-list-info">
    //           <Link
    //             to={`list/${listEntry.listid}`}
    //             className="contactDetailsList"
    //           >
    //             Navigate to list
    //           </Link>
    //           <div className="event-date">
    //             <p className="label">Event Date:</p>
    //             {formatTime(listEntry.primaryDate)}
    //           </div>
    //         </div>
    //
    //         {notesForPerson.length > 0 ? (
    //           renderNotesForList(notesForPerson)
    //         ) : (
    //           <p>No Notes</p>
    //         )}
    //       </Panel>
    //     </Collapse>
    //   );
    // }
  }

  function renderNotesForList(notes) {
    return (
      <>
        {notes.map((note, n) => (
          <div>{renderIndividualNote(note)}</div>
        ))}
      </>
    );
  }

  function renderIndividualNote(note) {
    var user = notesToUserInfo[note.userid];
    if (user === null || typeof user === "undefined") {
      ModelCache.getUserById(
        note.userid,
        user => {
          var local = notesToUserInfo;
          local[note.userid] = user;
          setNotesToUserInfo(local);
          setReloadProtocol(uuidv4());
        }
      );
    }

    return (
      <div className="sidepane-note-container">
        {user !== null && typeof user !== "undefined" ? (
          <div className="sidepane-note">
            {renderUser(user)}
            <div className="noteContent">
              <p>{note.notes}</p>
              {formatTime(note.updated)}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }

  function renderUser(user) {
    return <img className="avatar sm" src={user.picture} />;
  }

  return <div>{renderIndividualList(props.list.listid)}</div>;
});

export default ListSidePaneListSection;
